import { forwardRef, useImperativeHandle, useState, useMemo } from 'react';
import { Form, message, Modal } from "antd";
import { useRequest } from "ahooks";
import { EditForm, FormConfigType } from "../../../components/editForm";
import { AmountServer } from "../../../server";

const server = AmountServer.InternationalRemittanceCreditedTimesList;

const DEFAULT_OPERATION_DATA = {
    ChannelId: undefined,
    Name: '',
    NameEn: '',
    MaxLimit: '',
    MinLimit: '',
    Status: 1,
}

type OperateModeType = 'create' | 'update'

export const Operation = forwardRef((props: any, ref: any) => {
    const { onSuccess, options } = props;
    const [loading, setLoading] = useState<boolean>(false);
    const [visible, setVisiable] = useState<boolean>(false);
    const [formData, setFormData] = useState<any>({ ...DEFAULT_OPERATION_DATA });
    const [form] = Form.useForm();
    const [mode, setMode] = useState<OperateModeType>('create');

    useImperativeHandle(ref, () => ({
        changeVisible
    }))

    const changeVisible = (val: any, mode?: OperateModeType) => {
        if (val) {
            const data = {
                ...DEFAULT_OPERATION_DATA,
                ...(mode === 'update' ? val : {})
            };
            mode && setMode(mode)
            form?.resetFields?.();
            setFormData(data);
        } else {
            form?.resetFields?.();
        }
        setVisiable(!!val);
    }

    const { run } = useRequest(mode === 'create' ? server.create : server.update, {
        manual: true,
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => changeVisible(false),
        onSuccess: (res: any) => {
            message.success(mode === 'create' ? '新增成功' : '更新成功');
            changeVisible(false);
            onSuccess?.();
        }
    });

    const getBaseInfoFormConfig: FormConfigType = useMemo((): FormConfigType => {
        return [
            {
                title: "通道",
                field: "ChannelId",
                type: "select",
                placeholder: "请选择通道",
                options: options?.channelOptions || [],
                fieldNames: { label: 'name', value: 'id' },
                allowClear: true,
                required: true,
            },
            {
                title: "到账时效名称",
                field: "Name",
                type: "input",
                placeholder: "请输入到账时效名称",
                required: true,
            },
            {
                title: "到账时效英文名称",
                field: "NameEn",
                type: "input",
                placeholder: "请输入到账时效英文名称",
                required: true,
            },
            {
                title: "最小限额",
                field: "MinLimit",
                type: "input",
                placeholder: "请输入最小限额",
                required: true,
            },
            {
                title: "最大限额",
                field: "MaxLimit",
                type: "input",
                placeholder: "请输入最大限额",
                required: true,
            },
            {
                title: "状态",
                field: "Status",
                type: "select",
                placeholder: "请选择状态",
                required: true,
                options: [
                    { name: "启用", id: 1 },
                    { name: "禁用", id: 2 },
                ],
            },
        ];
    }, [formData, mode]);

    return (
        <div>
            <Modal
                title={mode === 'create' ? '新增通道时效' : '编辑通道时效'}
                width={500}
                closeIcon={null}
                maskClosable={false}
                open={visible}
                onCancel={() => changeVisible(false)}
                okButtonProps={{ loading }}
                onOk={async () => {
                    await form.validateFields();
                    run(formData);
                }}
            >
                <EditForm
                    componentId="credited-times-operation"
                    className="mt20"
                    form={form}
                    formAttrsProps={{
                        labelCol: { span: 8 },
                        wrapperCol: { span: 16 },
                    }}
                    formData={formData}
                    onDataChange={(data: any) => {
                        setFormData(data);
                    }}
                    formConfig={getBaseInfoFormConfig}
                />
            </Modal>
        </div>
    );
})
